export class metafields{
  public static all={
    "AboutUs": {
      "title": "About Vidhema Technology | Leading Web & Software Experts",
      "titleTemplate": "%s",
      "canonical":"https://www.vidhema.com/about-us.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Learn about Vidhema Technology, a leading web and software development company. Discover our expertise, values, and commitment to delivering innovative IT solutions."
        },
        {
          "name": "keyword",
          "content": "about us, web development company, software development, IT solutions, technology experts"
        },
       
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "About Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Discover Vidhema Technology, a leading web and software development company delivering innovative IT solutions.."
        },
        {
          "property": "og:type",
          "content": "website"
        },
      
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/about-us.html"
        },
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png",
          
        },
        {
          "name":"twitter:card",
          " content" :"summary"
        },
      
        {
          "name":"twitter:title",
          " content" :"Contact Vidhema Technologies"
        },
        {
          "name":"twitter:description",
          " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
        },
        {
          "name":"twitter:image",
          " content" :"https://www.vidhema.com/images/logo.png"
        },
        
    ]
      


    
    },


    "CareerDev": {
      "title": "Careers at Vidhema Technology | Join Our Innovative Tech Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/career.html",
        "meta": [
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
            },
          {
          "name": "description",
          "content": "Explore exciting career opportunities at Vidhema Technology. Join our team of innovative professionals in web and software development, and be part of cutting-edge tech projects. "
          },
          {
              "name": "keyword",
              "content": "tech jobs, software developer careers, web development jobs, IT careers, tech industry opportunities"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
        
            {
              "property": "og:type",
              "content": "website"
            },
            {
              "property": "og:title",
              "content":"Careers at Vidhema Technology",
            },
            
            {
              "property": "og:description",
              "content": "Join our innovative team at Vidhema Technology. Explore exciting career opportunities in web and software development. "
            },
        
          
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/career"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202282910387-972hiring-latest.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },
            {
              "name": "twitter:title",
              "content": "Grow your career with Vidhema Technologies",
            },
            {
              "name": "twitter:description",
              "content":  "Experience the best working environment and get a chance to work with the best clients globally. Check out our job openings and apply today! "
            },
        
            {
              "name": "twitter:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202282910387-972hiring-latest.jpg"
            },
         
        ]
    
    },
    "Blog": {
      "title": "Vidhema Technologies Blog | Information and Recent Technology Updates",
      "titleTemplate": "%s ",
      "canonical":"https://blog.vidhema.com",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
      {
    "name": "description",
    "content": "Vidhema Technologies Blog - Get the latest technology blog posts, recent updates of web and mobile application development."
      },
      {
        "name": "keyword",
        "content": "blog, new post, new blog,blog, technology blog posts, technology blog, the blog, information blog, blog posts"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Vidhema Technologies Blog | Information and Recent Technology Updates"
      },
      {
        "property": "og:description",
        "content": "Vidhema Technologies Blog - Get the latest technology blog posts, recent updates of web and mobile application development."
      },
      {
        "property": "og:type",
        "content": "blog"
      },
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/blog/"
      },
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },
      {
          "name": "twitter:title",
          "content": "Vidhema Technologies Blog | Information and Recent Technology Updates"
        },
      {
        "name": "twitter:description",
        "content": "Vidhema Technologies Blog - Get the latest technology blog posts, recent updates of web and mobile application development."
      },
    
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
     
  ]
    },
    "ContactUs": {
      "title": "Contact Vidhema Technology | Web & Software Development Experts",
      "titleTemplate": "%s - Vidhema Technologies",
      "canonical":"https://www.vidhema.com/contact-us.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
        {
      "name": "description",
      "content": "Contact Vidhema Technology for professional web and software development services. Get in touch with our expert team for custom solutions tailored to your business needs."
        },
        {
          "name": "keyword",
          "content": "contact, web development, software development, IT services, custom solutions"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Contact Vidhema Technologies for VueJS Development or Web & Mobile App"
        },
       
        {
          "property": "og:description",
          "content": "Get in touch with Vidhema Technology for professional web and software development services."
        },
  
        {
          "property": "og:type",
          "content": "website"
        },
        
       
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/contact-us.html"
        },
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png"
        },

        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
        {
          "name": "twitter:title",
          "content": "Contact Vidhema Technologies for VueJS Development or Web & Mobile App"
        },
        
        {
          "name": "twitter:description",
          "content": "Vidhema offer world-class web development solutions that are powerful and innovative. As a top web development company, we provide our services worldwide."
        },
        
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
      
    ]
      
    },
    "Microsoft365": {
      "title": " Microsoft 365 Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/microsoft-365.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
          
        {
          "name": "description",
          "content": "Enhance your business productivity with Vidhema Technology's Microsoft 365 services. Expert implementation, migration, and support for all Microsoft 365 applications."
        },
      {
          "name": "keyword",
          "content": " Microsoft 365, Office 365, cloud services, productivity tools, IT consulting, Microsoft Teams, SharePoint, Exchange Online."
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Microsoft 365 Services - Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Boost your business efficiency with our expert Microsoft 365 implementation and support services. Seamless integration of all Microsoft 365 apps."
        },
        {
          "property": "og:type",
          "content": "website"
        },
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/js-based-full-stack-development.html"
        },
        {
          "property": "og:image",
          "content": "https://www.vidhema.com/images/microsoft-365-services-og-image.jpg"
        },
        {
          "name":"twitter:card",
          " content" :"summary"
        },
      
        {
          "name":"twitter:title",
          " content" :"Contact Vidhema Technologies"
        },
        {
          "name":"twitter:description",
          " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
        },
        {
          "name":"twitter:image",
          " content" :"https://www.vidhema.com/images/logo.png"
        },
        
  
        
      ]
    },
    
  "MicrosoftAzure": {
    "title": " Microsoft Azure Services | Cloud Solutions by Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/microsoft-azure.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        
      {
        "name": "description",
        "content": "Leverage Vidhema Technology's expertise in Microsoft Azure cloud services. We offer tailored Azure solutions, migration services, and managed cloud infrastructure to optimize your business operations."
      },
    {
        "name": "keyword",
        "content": "Microsoft Azure, cloud services, Azure migration, cloud infrastructure, Azure consulting, cloud optimization"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Microsoft Azure Services by Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Enhance your business with Vidhema's Microsoft Azure cloud solutions. Expert consulting, migration, and management services available."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
  "MicrosoftDynamic": {
    "title": " Microsoft Dynamics Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/microsoft-dynamic.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Leverage Vidhema Technology's expertise in Microsoft Dynamics. We offer implementation, customization, and support services to optimize your business processes and drive growth."
      },
    {
        "name": "keyword",
        "content": "Microsoft Dynamics, CRM, ERP, business solutions, digital transformation, cloud services"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Microsoft Dynamics Services - Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Optimize your business with Vidhema's Microsoft Dynamics services. Expert implementation, customization, and support for CRM and ERP solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
  "MicrosoftNative": {
    "title": " Microsoft Native Development Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/microsoft-native.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Expert Microsoft Native development services from Vidhema Technology. We create powerful, efficient applications for Windows, Xbox, and other Microsoft platforms."
      },
    {
        "name": "keyword",
        "content": " Microsoft Native development, Windows app development, Xbox game development, .NET development, C# programming"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Microsoft Native Development Services - Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Expert Microsoft Native development services. Create powerful applications for Windows, Xbox, and other Microsoft platforms with Vidhema Technology."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
  
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
    "MicrosoftBusiness": {
    "title": " Microsoft Business Central Solutions | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/microsoft-business-controller.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Optimize your business operations with Vidhema Technology's Microsoft Business Central solutions. Streamline finances, operations, and customer service with our expert implementation and support."
      },
    {
        "name": "keyword",
        "content": " Microsoft Business Central, ERP solutions, business management software, financial management, supply chain optimization."
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Microsoft Business Central Solutions | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Streamline your business operations with Vidhema Technology's expert Microsoft Business Central implementation and support services."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
    "MicrosoftPowerBI": {
    "title": " Microsoft Power BI Services | Data Visualization & Analytics | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/microsoft-power-bi.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Transform your data with Vidhema Technology's Microsoft Power BI services. Expert implementation, custom dashboards, and advanced analytics solutions for informed decision-making."
      },
    {
        "name": "keyword",
        "content": " Microsoft Power BI, data visualization, business intelligence, analytics, data insights, Power BI consulting"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Microsoft Power BI Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Unlock the power of your data with Vidhema Technology's expert Microsoft Power BI services. Custom solutions for data-driven decision making."
      },
      {
        "property": "og:type",
        "content": "website"
      },
      
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
    
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  
  },
  "OracleDEV": {
    "title": " Oracle Development Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/oracle-development.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Oracle development services. Our team provides custom Oracle solutions to meet your business needs."
      },
    {
        "name": "keyword",
        "content": " Oracle development, custom Oracle solutions, database management, IT services, Vidhema Technology"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Oracle Development Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Reach out to Vidhema Technology for expert Oracle development services."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
      
    ]
  },
  "OdooDEV": {
    "title": " Odoo Development Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/odoo-development.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Odoo development services. Our team specializes in custom Odoo solutions to enhance your business operations."
      },
    {
        "name": "keyword",
        "content": " Odoo development, Odoo customization, ERP solutions, business automation, custom Odoo services"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Odoo Development Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Contact Vidhema Technology for expert Odoo development services and custom Odoo solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
  "sapDEV": {
    "title": " sap solutions Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://vidhema.com/sap-solution.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert sap development services. Our team specializes in custom sap solutions to enhance your business operations."
      },
    {
        "name": "keyword",
        "content": " sap development, sap customization, ERP solutions, business automation, custom sap services"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "sap solutions Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Contact Vidhema Technology for expert sap development services and custom sap solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
    ]
  },
  "SalesforceDEV": {
    "title": " Salesforce Development Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/salesforce-development.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Salesforce development services. Our team delivers custom Salesforce solutions to optimize your business processes"
      },
    {
        "name": "keyword",
        "content": "Salesforce development, CRM solutions, custom Salesforce solutions, business optimization"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Salesforce Development Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Get in touch with Vidhema Technology for expert Salesforce development services and custom CRM solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
      
    ]
  },
  "HubspotDEV": {
    "title": " Hubspot CRM Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://www.vidhema.com/hubspot.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Hubspot CRM services. Our team delivers custom Hubspot solutions to optimize your business processes"
      },
    {
        "name": "keyword",
        "content": "Hubspot development, CRM solutions, custom Hubspot solutions, business optimization, CRM"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Hubspot CRM Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Get in touch with Vidhema Technology for expert Hubspot development services and custom CRM solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/hubspot.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
      
    ]
  },
  "tableauDEV": {
    "title": " Tableau solutions Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://vidhema.com/tableau.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Tableau solutions services. Our team delivers custom Tableau solutions to optimize your business processes"
      },
    {
        "name": "keyword",
        "content": "Tableau solutions, CRM solutions, custom Tableau solutions, business optimization"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Tableau solutions Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Get in touch with Vidhema Technology for expert Tableau solutions services and custom CRM solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
      
    ]
  },
  "adobeDEV": {
    "title": " Adobe experience Services | Vidhema Technology",
    "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://vidhema.com/adobe-experience.html",
    "meta": [
      {
        "name": "viewport",
        "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
        "name": "description",
        "content": "Contact Vidhema Technology for expert Adobe experience services. Our team delivers custom Adobe experience to optimize your business processes"
      },
    {
        "name": "keyword",
        "content": "Adobe experience, CRM solutions, custom Adobe experience, business optimization"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Adobe experience Services | Vidhema Technology"
      },
      {
        "property": "og:description",
        "content": "Get in touch with Vidhema Technology for expert Adobe experience services and custom CRM solutions."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/js-based-full-stack-development.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name":"twitter:card",
        " content" :"summary"
      },
    
      {
        "name":"twitter:title",
        " content" :"Contact Vidhema Technologies"
      },
      {
        "name":"twitter:description",
        " content" :"Get in touch with Vidhema Technologies for expert IT solutions and support."
      },
      {
        "name":"twitter:image",
        " content" :"https://www.vidhema.com/images/logo.png"
      },
      
    ]
  },
   "MobIOS": {
      "title": "Acclaimed ios app development company offering ios development services",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/ios-app-development.html",
    "meta": [ 
      {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
    },

      {
    "name": "description",
    "content":  "Having years of experience in iOS development, we are a highly renowned ios app development company. Get the best ios app development services from our expert ios app development team. We are committed on delivering end-to-end projects to our customers within a given time."
    },
    {
        "name": "keyword",
        "content": "ios app development, ios development, ios development services, iphone app development, ios app development services, ios app development company, ios mobile app development, top ios app development company"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content":"Acclaimed ios app development company offering ios development services",
      },
      {
        "property": "og:description",
        "content":"Having years of experience in iOS development, we are a highly renowned ios app development company. Get the best ios app development services from our expert ios app development team. We are committed on delivering end-to-end projects to our customers within a given time."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/ios-app-development.html"
      },
    
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":  "Having years of experience in iOS development, we are a highly renowned ios app development company. Get the best ios app development services from our expert ios app development team. We are committed on delivering end-to-end projects to our customers within a given time."
      },
      {
        "name": "twitter:title",
        "content": "Acclaimed ios app development company offering ios development services",
      },
     
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      
  ]
    
    },
    "HireAndroid": {
      "title": "Hire Android App Developers | Android App Development Company India",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-android-developers.html",
        "meta": [
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
          {
          "name": "description",
          "content": "Our team of Android App Developers offers world-class Android App Development Services. You can hire dedicated Android Programmers on an hourly, weekly, or monthly basis."
          },
          {
              "name": "keyword",
              "content": "hire android developers, hire android app developer, hire dedicated android developer, android developers, hire dedicated android app developer, android app development company, android app development services"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Dedicated Android App Developers | Android App Development Company India",
            },
            {
              "property": "og:description",
              "content": "Our team of Android App Developers offers world-class Android App Development Services. You can hire dedicated Android Programmers on an hourly, weekly, or monthly basis."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-android-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Our team of Android Developers offers world-class Android App Development Services. You can hire dedicated Android Developers on an hourly, weekly, or monthly basis."
            },
            {
              "name": "twitter:title",
              "content": "Hire Dedicated Android App Developers | Hire Android Developers - Vidhema Technologies",
            },
         
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireFlutter": {
      "title": "Hire Flutter App Developers | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/flutter-development.html",
        "meta": [
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
          {
          "name": "description",
          "content": "Hire expert Flutter app developers from Vidhema Technology. Our skilled developers create high-quality, cross-platform mobile applications using Flutter."
          },
          {
              "name": "keyword",
              "content": "Hire Flutter Developers, Flutter App Development, Cross-Platform Mobile Development, Flutter Development Company"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Flutter App Developers at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Hire expert Flutter app developers from Vidhema Technology. Our skilled developers create high-quality, cross-platform mobile applications using Flutter."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-flutter-developers.html"
            },
        
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Vidhema Technologies is a renowned Flutter App Development Company. You can hire Flutter App Developers India from us to accelerate the revenue of your business"
            },
            {
              "name": "twitter:title",
              "content": "Hire Flutter App Developers India | Flutter App Development Company",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
          
        ]
    
    },
    "HireIonic": {
      "title": "Hire Ionic Developers | Expert Ionic App Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-ionic-developers.html",
        "meta": [
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
          },
          {
          "name": "description",
          "content": "Hire expert Ionic developers from Vidhema Technology. Our skilled team delivers high-quality, cross-platform mobile apps using the latest Ionic framework."
          },
          {
              "name": "keyword",
              "content": "hire Ionic developers, Ionic app development, cross-platform mobile apps, expert Ionic programmers, Ionic framework services"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Ionic Developers at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": " Hire expert Ionic developers from Vidhema Technology for high-quality, cross-platform mobile app development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-ionic-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  " Hire Ionic Developer from Vidhema Technologies. Our team of Ionic App Development has expertise in developing effective cross-platform Ionic mobile apps."
            },
            {
              "name": "twitter:title",
              "content": "Hire Ionic Developer | Ionic App Development",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
    "HireReactNative": {
      "title": "Hire React Native Developers | Join Vidhema Technology's Mobile App Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/react-native.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring skilled React Native Developers. Join our innovative team to create cutting-edge mobile applications and advance your career in cross-platform mobile development.."
          },
          {
              "name": "keyword",
              "content": "React Native developer job, hire mobile app developer, cross-platform development career, React programming, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire React Native Developers at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as a React Native Developer. Create innovative mobile apps and grow your career in cross-platform development"
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-react-native-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire React Native Developers from Vidhema Technologies & get top-notch React Native App Development Services. We offer a team of the best-hired React programmers."
            },
            {
              "name": "twitter:title",
              "content": "Hire React Native Developers | Hire React Programmer",
            },
         
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
         
        ]
    
    },
"FrontDev": {
      "title": "Front-end Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/front-end-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Vidhema Technology offers expert front-end development services. Create responsive, user-friendly websites and web applications with our skilled team of developers."
      },
      {
          "name": "keyword",
      "content": "front-end development, web design, responsive websites, UI development, JavaScript frameworks, React, Angular, Vue.js"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Front-end Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Expert front-end development services by Vidhema Technology. Create stunning, responsive websites and web applications."
        },
        {
          "property": "og:type",
          "content": "FrontDev"
        },
        
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/front-end-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Onboard certified front-end developers for customized front-end web development services with advanced UI design from the leading front end development company."
        },
        {
          "name": "twitter:title",
          "content": "Front-End Development Services - Vidhema Technologies"
        },
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        
    ]
    },
    "EcommDev": {
      "title": "E-commerce Website Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/ecommerce-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Transform your business with Vidhema Technology's expert e-commerce website development services. We create robust, scalable, and user-friendly online stores tailored to your unique needs."
      },
      {
          "name": "keyword",
      "content": "e-commerce development, online store creation, custom e-commerce solutions, e-commerce website design, shopping cart development"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "E-commerce Website Development Services | Vidhema Technology "
        },
        {
          "property": "og:description",
          "content": "Create powerful online stores with Vidhema Technology's expert e-commerce website development services. Tailored solutions for your business growth."
        },
        {
          "property": "og:type",
          "content": "EcommDev"
        },
       
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/ecommerce-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Best ecommerce website development company offering the finest ecommerce solutions for various industries. Our ecommerce developers offer you the top custom ecommerce solutions."
        },
        {
          "name": "twitter:title",
          "content": "Ecommerce Development Company | Ecommerce Developers - Vidhema Technologies"
        },
        
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
    },
"CmsDev": {
      "title": "CMS Website Development Company | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://vidhema.com/cms-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Vidhema Technology: Your trusted CMS website development company. We create powerful, customized CMS solutions using WordPress, Drupal, and more to meet your unique business needs."
      },
      {
          "name": "keyword",
      "content": "CMS development, content management system, WordPress development, Drupal development, custom CMS solutions"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "CMS Website Development Company | CMS ProgrammerCMS Website Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Vidhema Technology offers expert CMS website development services. Get a powerful, customized CMS solution for your business needs."
        },
        {
          "property": "og:type",
          "content": "CmsDev"
        },
     
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/cms-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "We are the top CMS website development company, providing custom CMS website development services at an affordable price. Hire a CMS programmer by connecting with our team."
        },
        {
          "name": "twitter:title",
          "content": "CMS Website Development Company | CMS Programmer"
        },
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        
    ]
    },
    "WebApp": {
      "title": " Web Application Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
    "canonical":"https://vidhema.com/web-application-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Vidhema Technology offers cutting-edge web application development services. Our expert team delivers custom, scalable, and user-friendly web solutions to drive your business growth."
      },
      {
          "name": "keyword",
          "content": "web application development, custom web solutions, enterprise web apps, responsive web design, full-stack development"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Web Application Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Empower your business with custom, scalable web applications. Vidhema Technology delivers innovative web solutions tailored to your unique needs."
        },
        {
          "property": "og:type",
          "content": "website"
        },
      
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/web-application-development.html"
        },
        
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "We are a leading web application development company and provide web application development services to our clients along with professional custom web design services. Hire our web developers for the best offerings."
        },
        {
          "name": "twitter:title",
          "content": "Web Application Development Company | Website Development Services"
        },
    ,
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        
    ]
    },
    "FullStackDev": {
      "title": "JavaScript Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
   "canonical":"https://www.vidhema.com/js-based-full-stack-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Expert JavaScript development services from Vidhema Technology. We create dynamic, responsive web applications using cutting-edge JavaScript frameworks and libraries."
      },
      {
          "name": "keyword",
      "content": "JavaScript development, web applications, front-end development, React, Angular, Vue.js, Node.js"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "JavaScript Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Expert JavaScript development services for dynamic, responsive web applications. Leverage our expertise in modern JavaScript frameworks and libraries."
        },
        {
          "property": "og:type",
          "content": "website"
        },
      
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/js-based-full-stack-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "We are a top JavaScript Development Company offering end-to-end JavaScript Development Services. Hire our expert JavaScript Developers for custom JS Development Services."
        },
        {
          "name": "twitter:title",
          "content": "Hire JavaScript Developer | JavaScript Development Services"
        },
      
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
    ]
    },
    "NFTdevelopmentSerives": {
      "title": "NFT Development Company |Vidhema Technology ",
      "titleTemplate": "%s | Vidhema Technologies",
   "canonical":"https://vidhema.com/nft-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
    "name": "description",
    "content":  "Vidhema Technology for professional NFT development services. Get in touch with our expert team for custom NFT solutions tailored to your business needs "
    },
    {
        "name": "keyword",
        "content":  "NFT development, blockchain, custom NFT solutions, digital assets"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content":"NFT Development Company |Vidhema Technology ",
      },
      {
        "property": "og:description",
        "content":"Discover Vidhema Technology's expertise in NFT development, delivering innovative solutions for creating and managing non-fungible tokens."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://www.vidhema.com/nft-development.html"
      },
      
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":"Vidhema Technologies is an NFT development company that offers a wide range of NFT development services to its clients, from entrepreneurs to SMEs and large enterprises. "
      },
      {
        "name": "twitter:title",
        "content": "NFT Development Company | NFT Development Services",
      },
    
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      
  ]
    },
    "ARAppDev": {
      "title": " Augmented Reality App Development  | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/augumented-reality.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Contact Vidhema Technology for professional augmented reality development services. Our expert team delivers custom AR solutions tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "contact, augmented reality development, AR solutions, custom AR development, immersive technology"
            },{
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Augmented Reality App Development |Vidhema Technologies",
            },
            {
              "property": "og:description",
              "content": "Get in touch with Vidhema Technology for professional augmented reality development services."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/augumented-reality.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "We are one of the top Augmented Reality App Development Company offering the best Augmented Reality Service to accelerate your business growth. We develop AR & VR solutions as per client needs."
            },
            {
              "name": "twitter:title",
              "content": "Augmented Reality App Development Services - Vidhema Technologies",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "ProgressWebApp": {
      "title": "Progressive Web App Development | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
     "canonical":"https://www.vidhema.com/progressive-web-app-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Leverage Vidhema Technology's expertise in Progressive Web App (PWA) development. Create fast, reliable, and engaging web applications that work across all devices and platforms."
      },
      {
          "name": "keyword",
          "content": "Progressive Web Apps, PWA development, mobile-first web apps, offline-capable apps, responsive web design"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Progressive Web App Development | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Create fast, reliable, and engaging Progressive Web Apps with Vidhema Technology. Expert PWA development for all devices and platforms."
        },
        {
          "property": "og:type",
          "content": "website"
        },
       
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/progressive-web-app-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Progressive Web App Development Company Vidhema Technologies offers seamless progressive web app development services to create a secure and high-performance PWA. Call us to hire PWA web app developers."
        },
        {
          "name": "twitter:title",
          "content": "Progressive Web App Development Company | PWA Developers"
        },
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
     
    ]
    },
    "Youtube":{
      "title":"YouTube Marketing Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
       "canonical":"https://vidhema.com/youtube-marketing-services.component.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Boost your online presence with our YouTube marketing services. Vidhema Technology helps you create engaging video content and grow your audience effectively."
          },
          {
              "name": "keyword",
              "content": "YouTube marketing, video marketing, YouTube SEO, online video promotion, video content creation.    "
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"YouTube Marketing Services | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Boost your online presence with our YouTube marketing services. Vidhema Technology helps you create engaging video content and grow your audience effectively."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/youtube-marketing-services.component.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Use Vidhema Technologies' all-inclusive marketing services to boost your brand's visibility on YouTube. We are your go-to partner for success in everything from channel optimization and analytics to content creation."
            },
            {
              "name": "twitter:title",
              "content": "Vidhema Technologies' YouTube Marketing Services",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    },
    "AEM":{
      "title":"Contact Vidhema Technology | AEM CMS Development Services",
      "titleTemplate": "%s | Vidhema Technologies",
       "canonical":"https://www.vidhema.com/aem-cms-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Contact Vidhema Technology for professional AEM CMS development services. Our expert team provides custom AEM solutions to enhance your digital experiences."
          },
          {
              "name": "keyword",
              "content": "contact, AEM CMS development, Adobe Experience Manager, custom AEM solutions, digital experiences"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Contact Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Get in touch with Vidhema Technology for professional AEM CMS development services."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/aem-cms-development.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Elevate your digital presence with Vidhema Technologies, a trusted partner offering cutting-edge AEM (Adobe Experience Manager) CMS development services."
            },
            {
              "name": "twitter:title",
              "content": "Leading the Way in AEM CMS Development Services and Adobe AEM Solutions",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    },
    "MagentoApp": {
      "title": "Magento Mobile App Development | Vidhema Technology",
      "titleTemplate": "%s | Vidhema",
      "canonical":"https://www.vidhema.com/magento-mobile-app-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Transform your Magento store into a powerful mobile app. Vidhema Technology offers expert Magento mobile app development services to boost your e-commerce business."
      },
      {
          "name": "keyword",
          "content": "Magento mobile app, e-commerce app development, Magento 2 mobile app, mobile commerce solutions"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Magento Mobile App Development | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Transform your Magento store into a powerful mobile app. Expert Magento mobile app development services by Vidhema Technology."
        },
        {
          "property": "og:type",
          "content": "website"
        },
      
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/magento-mobile-app-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Our Android & iOS mobile apps are fully compatible with your Magento web store. Boost the sales and growth of your business with our productive and engaging app design services."
        },
        {
          "name": "twitter:title",
          "content": "Magento Mobile App Builder | Android & iOS App"
        },
         
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
    },
    "EcommShopify": {
      "title": "Shopify App Development Company | Shopify Web Designer  - Vidhema Technologies",
      "titleTemplate": "%s | Vidhema",
     "canonical":"https://vidhema.com/shopify-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
    "name": "description",
    "content": "Are you looking to hire an adroit Shopify expert? We are a leading Shopify website development company offering its services around the globe."
    },
    {
        "name": "keyword",
        "content": "shopify developer, shopify development company, shopify app development, shopify web designer, shopify development agency, shopify website developer, shopify app development company, shopify expert"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content": "Shopify App Development Company | Shopify Web Designer  - Vidhema Technologies",
      },
      {
        "property": "og:description",
        "content":"Are you looking to hire an adroit Shopify expert? We are a leading Shopify website development company offering its services around the globe."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://vidhema.com/shopify-development.html"
      },
      
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":"Are you looking to hire an adroit Shopify expert? We are a leading Shopify website development company offering its services around the globe."
      },
      {
        "name": "twitter:title",
        "content": "Shopify App Development Company | Shopify Web Designer  - Vidhema Technologies",
      },
    
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
    
  ]
    },
    "HireShopware": {
      "title": "Hire Shopware Developer | Join Vidhema Technology's E-commerce Team",
      "titleTemplate": "%s | Vidhema Technologies",
       "canonical":"https://vidhema.com/hire-shopware-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring skilled Shopware Developers. Join our e-commerce team to create cutting-edge online stores and advance your career in Shopware development."
          },
          {
              "name": "keyword",
              "content": "shopware developer job, hire shopware expert, e-commerce development career, shopware programming position, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Shopware Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as a Shopware Developer. Create innovative e-commerce solutions and grow your career in Shopware development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-shopware-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire Shopware Developers from Vidhema Technologies for your next project. We have a team of experienced shopify experts at affordable rates."
            },
            {
              "name": "twitter:title",
              "content": "Hire Shopware Developer | Hire Shopify Experts",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
"EcommPrestashop": {
      "title": "Leading prestashop development company offering Prestashop services",
      "titleTemplate": " | Vidhema Technologies",
    "canonical":"https://vidhema.com/prestashop.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
    "name": "description",
    "content":  "Prestashop is an excellent professional platform for developers & enterprises. We provide adaptable Prestashop development services to create an efficient website at affordable costs."
    },
    {
        "name": "keyword",
        "content": "prestashop development company, prestashop development services, prestashop, prestashop services"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content":"Leading prestashop development company offering Prestashop services",
      },
      {
        "property": "og:description",
        "content":"Prestashop is an excellent professional platform for developers & enterprises. We provide adaptable Prestashop development services to create an efficient website at affordable costs."
      },
      {
        "property": "og:type",
        "content": "website"
      },
    
      {
        "property": "og:url",
        "content": "https://vidhema.com/prestashop.html"
      },
  
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":"Prestashop is an excellent professional platform for developers & enterprises. We provide adaptable Prestashop development services to create an efficient website at affordable costs."
      },
      {
        "name": "twitter:title",
        "content": "Leading prestashop development company offering Prestashop services",
      },
    
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
     
  ]
    },
   
   
    "WebPHP": {
      "title": "Get the leading php web design services from the best php programmer - Vidhema Technologies",
      "titleTemplate": "%s | Vidhema Technologies",
      
      "canonical":"https://vidhema.com/hire-php-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
    "name": "description",
    "content":  "As a leading php web development company, we aim to implement a secure and powerful server-side for all kinds of web applications. We render php development solutions to meet the need of the enterprises."
    },
    {
        "name": "keyword",
        "content": "php development services, php web development, php development, php programmer, php laravel developer, php web development company, php web design"
      },
      {
        "name":"revisit-after",
        "content":"7 days",
      },
      {
        "property": "og:title",
        "content":"Get the leading php web design services from the best php programmer - Vidhema Technologies",
      },
      {
        "property": "og:description",
        "content":"As a leading php web development company, we aim to implement a secure and powerful server-side for all kinds of web applications. We render php development solutions to meet the need of the enterprises."
      },
      {
        "property": "og:type",
        "content": "website"
      },
     
      {
        "property": "og:url",
        "content": "https://vidhema.com/hire-php-developers.html"
      },
     
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":"As a leading php web development company, we aim to implement a secure and powerful server-side for all kinds of web applications. We render php development solutions to meet the need of the enterprises."
      },
      {
        "name": "twitter:title",
        "content": "Get the leading php web design services from the best php programmer - Vidhema Technologies",
      },
      
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      
  ]
    },
    "WebPython": {
      "title": "Experience the best Full-Stack Python Development from our experts - Vidhema Technologies",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-php-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
      {
    "name": "description",
    "content":"Vidhema Technologies has been offering the best Python Development Services to help you expand your business. As the growing Python Development Company, we do engaging Python Mobile App Development for your business."
    },
    {
      "name":"revisit-after",
      "content":"7 days",
    },
  
    {
        "name": "keyword",
        "content":  "python development services, python web development, python development company, python mobile app development, python development, full stack python"
      },
      {
        "property": "og:title",
        "content":"Experience the best Full-Stack Python Development from our experts - Vidhema Technologies",
      },
      {
        "property": "og:description",
        "content":"Vidhema Technologies has been offering the best Python Development Services to help you expand your business. As the growing Python Development Company, we do engaging Python Mobile App Development for your business."
      },
      {
        "property": "og:type",
        "content": "website"
      },
      
      {
        "property": "og:url",
        "content": "https://vidhema.com/hire-php-developers.html"
      },
      
      {
        "property": "og:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
      {
        "name": "twitter:card",
        "content": "summary_large_image"
      },

      {
        "name": "twitter:description",
        "content":"Vidhema Technologies has been offering the best Python Development Services to help you expand your business. As the growing Python Development Company, we do engaging Python Mobile App Development for your business."
      },
      {
        "name": "twitter:title",
        "content": "Experience the best Full-Stack Python Development from our experts - Vidhema Technologies",
      },
     
      {
        "name": "twitter:image",
        "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
      },
     
  ]
    },
    "MobAndroid": {
      "title": "Android App Development Company | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/android-app-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is a leading Android app development company. We create high-quality, user-friendly, and feature-rich Android applications tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "Android App Development, Android Development Company, Mobile App Development, Custom Android Apps"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Android App Development Company | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Vidhema Technologies offering the great android app development services. We are the top android app development company. Connect with us & we will develop an engaging application for your businessVidhema Technology is a leading Android app development company. We create high-quality, user-friendly, and feature-rich Android applications tailored to your business needs."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/android-app-development.html"
            },
           
            {
              "property": "og:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Vidhema Technologies offering the great android app development services. We are the top android app development company. Connect with us & we will develop an engaging application for your business."
            },
            {
              "name": "twitter:title",
              "content": "Top android app development company offering services with interactive features - Vidhema Technologies",
            },
            
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireIOS": {
      "title": "Hire iOS App Developer | Join Vidhema Technology's Mobile Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-ios-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring talented iOS App Developers. Join our innovative team to create cutting-edge mobile applications and advance your career in iOS development."
          },
          {
              "name": "keyword",
              "content": "iOS developer job, hire Swift programmer, Apple app development, mobile dev career, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire iOS App Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Hire dedicated iOS Developers in India who can boost your business growth with iOS app development services. Hire an iOS programmer in easy steps by connecting with us now! "
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-ios-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire dedicated iOS Developers in India who can boost your business growth with iOS app development services. Hire an iOS programmer in easy steps by connecting with us now!"
            },
            {
              "name": "twitter:title",
              "content": "Hire iOS App Developer in India | Hire iOS Developer",
            },
            
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "FlutterAppDev": {
      "title": "Flutter App Development | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/flutter-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology offers expert Flutter app development services. Contact us to create high-performance, cross-platform mobile applications tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "Flutter app development, cross-platform apps, mobile app development, Flutter development services, Vidhema Technology"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Flutter App Development | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Contact Vidhema Technology for expert Flutter app development services and create high-performance, cross-platform mobile applications."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/flutter-development.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "As a leading Flutter App Development Company, we offer Flutter App Developers to help businesses grow by developing budget-friendly native apps for operating systems."
            },
            {
              "name": "twitter:title",
              "content": "Flutter App Development Company | Flutter app Development Services",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "ReactnativeAppDev": {
      "title": "React Native App Development | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/react-native.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology offers expert React Native app development services. Our team delivers high-quality, cross-platform mobile applications tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "React Native app development, cross-platform mobile apps, mobile app development, Vidhema Technology"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"React Native App Development | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Vidhema Technology offers expert React Native app development services. Our team delivers high-quality, cross-platform mobile applications tailored to your business needs."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/react-native.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Vidhema Technologies is a leading React Native app development company that offers React Native developers for Android and iOS in India and Singapore."
            },
            {
              "name": "twitter:title",
              "content": "React Native App Development Company | React Native Developer",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
   
    "CaseStudies": {
      "title": "Case Studies | Vidhema Technologies",
      "titleTemplate": "%s - Vidhema Technologies",
      "canonical":"https://vidhema.com/case-studies.html",
      "meta": [
        {
      "name": "description",
      "content": "Vidhema Technologies is known for Delivering exceptional eCommerce Development, Mobile App Development, CRM Solutions and ERP Solutions."
      },
        {
      "name": "description",
      "content": "Success Stories where we helped our clients achieve their goals! Get an in-depth understanding of our projects with the help of these case studies."
        },
        {
          "name": "keyword",
          "content": "case studies,success stories"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Contact Vidhema Technologies for VueJS Development or Web & Mobile App"
        },
        {
          "property": "og:description",
          "content": "Vidhema offers world-class web development solutions that are powerful and innovative. As a top web development company, we provide our services worldwide."
        },
        {
          "property": "og:type",
          "content": "blog"
        },
      
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/about-us.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Vidhema offers world-class web development solutions that are powerful and innovative. As a top web development company, we provide our services worldwide."
        },
        {
          "name": "twitter:title",
          "content": "Contact Vidhema Technologies for VueJS Development or Web & Mobile App"
        },
      
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
      
    },
    "Home": {
      "title": "Vidhema Technologies | Innovative IT Solutions & Services",
      "titleTemplate": "%s | Vidhema",
      "canonical":"https://www.vidhema.com/",
      "meta": [
        {
      "name": "description",
      "content": "Vidhema Technologies is known for Delivering exceptional eCommerce Development, Mobile App Development, CRM Solutions and ERP Solutions."
      },
      {
          "name": "keyword",
          "content": "web design company, web development agency, ecommerce development services, outsource web application development, custom website development services, custom web development company, web application framework, best website design, Top mobile app development company"
        },
        {
          "name":"revisit-after",
          "content":"3 days",
        },
      
        {
          "property": "og:title",
          "content": "Vidhema Technologies ERP: Mobile App Development Company India, Singapore"
        },
        {
          "property": "og:description",
          "content": "Vidhema Technologies is a prominent top web and mobile app development company in India & Singapore, providing custom website development services across the world. Outsource web application development & expand your business globally."
        },
        {
          "property": "og:type",
          "content": "https://www.vidhema.com/"
        },
       
     
        {
          "property": "og:url",
          "content": "https://www.vidhema.com/"
        },
    
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png"
        },
        { 
          "name": "twitter:card",
          "content": "summary_large_image"
        },
        {
          "name": "twitter:title",
          "content": "Vidhema Technologies: Mobile App Development Company India, Singapore"
        },
        {
          "name": "twitter:description",
          "content": "Vidhema Technologies is a prominent top web and mobile app development company in India & Singapore, providing custom website development services across the world. Outsource web application development & expand your business globally."
        },
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
      
    ]
    },
   
    "Portfolio": {
      "title": "Mobile & Web Application Portfolio | Vidhema Technology",
      "titleTemplate": "%s",
      "canonical":"https://vidhema.com/portfolio.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Explore Vidhema Technology's portfolio of innovative mobile and web applications. Discover our expertise in creating cutting-edge digital solutions across various industries."
        },
        {
          "name": "keyword",
          "content": "mobile apps, web applications, app portfolio, software development projects, digital solutions"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content":" Mobile & Web Application Portfolio - Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Discover Vidhema Technology's innovative mobile and web applications. See our expertise in action through our diverse portfolio of digital solutions."
        },
        {
          "property": "og:type",
          "content": "blog"
        },
     
        {
          "property": "og:url",
          "content": "https://vidhema.com/portfolio.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/2021322124931-498vidhema-logoblack1.png"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Drive traffic to your website with our full suite of web development services. We offer custom software development solutions. Visit us to see our work portfolio."
        },
        {
          "name": "twitter:title",
          "content": "Portfolio - Welcome to Vidhema Technologies"
        },
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
      
    },
    
   
  
    "MagentoDevelopment": {
      "title": "Magento Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
     "canonical":"https://vidhema.com/magento-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Expert Magento development services from Vidhema Technology. Custom e-commerce solutions, Magento store optimization, and seamless integrations for your online business."
      },
      {
          "name": "keyword",
      "content": "Magento development, e-commerce solutions, custom Magento store, Magento integration, Magento optimization"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
       
     
        {
          "property": "og:title",
          "content": "Magento Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Expert Magento development services for your e-commerce business. Custom solutions, optimization, and seamless integrations by Vidhema Technology."
        },
        {
          "property": "og:type",
          "content": "website"
        },
       
        {
          "property": "og:url",
          "content": "https://vidhema.com/magento-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "We are the Trusted Magento Development Company for Top-notch Magento Development Services. Enhance your online presence with our expert Magento solutions.."
        },
        {
          "name": "twitter:title",
          "content": "Magento Development Company | Magento Development Services"
        },
        
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
      
    ]
    },
    "ShopwareDevelopment": {
      "title": "Shopware Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/shopware-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
          "content": "Expert Shopware development services from Vidhema Technology. Create powerful, customized e-commerce solutions with our skilled Shopware developers."
      },
      {
          "name": "keyword",
      "content": "Shopware development, e-commerce solutions, custom Shopware plugins, Shopware theme development, Shopware integration"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
      
        {
          "property": "og:title",
          "content": "Shopware Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Create powerful, customized e-commerce solutions with our expert Shopware development services."
        },
        {
          "property": "og:type",
          "content": "website"
        },
       
        {
          "property": "og:url",
          "content": "https://vidhema.com/shopware-development.html"
        },
     
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "We are a leading Shopware development company that can help you in converting your business into a top enterprise. Connect with us to get the top services!"
        },
        {
          "name": "twitter:title",
          "content": "Shopware Development Company | Shopware Development Services"
        },
       
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
  },

    "ShopifyDevelopment": {
      "title": "Shopify Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema",
     "canonical":"https://vidhema.com/shopify-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
        {
      "name": "description",
      "content": "Expert Shopify development services by Vidhema Technology. Custom e-commerce solutions, theme development, app integration, and optimization for your online store."
      },
      {
          "name": "keyword",
          "content": "Shopify development, e-commerce solutions, custom theme development, Shopify app integration, online store optimization"
        },
        {
          "name":"revisit-after",
          "content":"7 days",
        },
        {
          "property": "og:title",
          "content": "Shopify Development Services | Vidhema Technology"
        },
        {
          "property": "og:description",
          "content": "Boost your e-commerce with our expert Shopify development services. Custom solutions, theme development, and optimization for your online store."
        },
        {
          "property": "og:type",
          "content": "website"
        },
      
        {
          "property": "og:url",
          "content": "https://vidhema.com/shopify-development.html"
        },
       
        {
          "property": "og:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
        {
          "name": "twitter:card",
          "content": "summary_large_image"
        },
  
        {
          "name": "twitter:description",
          "content": "Vidhema Technologies is a certified Shopify development company offering Shopify development services for your business. Get your project done now with our experts!"
        },
        {
          "name": "twitter:title",
          "content": "Shopify Development Services | Shopify Development Company"
        },
     
        {
          "name": "twitter:image",
          "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
        },
       
    ]
    },

    "HireJava": {
      "title": "Hire Java Developer | Join Vidhema Technology's Expert Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-java-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring experienced Java Developers. Join our innovative team to work on cutting-edge projects and advance your career in software development."
          },
          {
              "name": "keyword",
              "content": "java developer job, hire java programmer, java coding career, software engineering position, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Java Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as a Java Developer. Work on innovative projects and grow your career in software development."
            },
          
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-java-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire professional Java developers from Vidhema Technologies.   Achieve your business goals with our professional java programmers for a good price in India."
            },
            {
              "name": "twitter:title",
              "content": "Hire Java Developer India | Hire Java Programmer Online",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
 },
    "HireDotnet": {
      "title": "Hire ASP.NET Developer | Join Vidhema Technology's Expert Team",
      "titleTemplate": "%s | Vidhema Technologies",
       "canonical":"https://vidhema.com/hire-dotnet-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is seeking skilled ASP.NET Developers. Join our innovative team to work on cutting-edge web applications and advance your career in .NET development."
          },
          {
              "name": "keyword",
              "content": "ASP.NET developer job, hire .NET programmer, C# coding career, web development position, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire ASP.NET Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as an ASP.NET Developer. Work on innovative web projects and grow your career in .NET development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
         
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-dotnet-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire dedicated .Net Developers from the leading ASP.Net development company to grow your business with no overhead costs & get reliable web apps that are user-centric."
            },
            {
              "name": "twitter:title",
              "content": "Hire ASP.Net Developers | Hire dot Net Developer",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HirePHP": {
      "title": "Hire Dedicated PHP Developers | Join Vidhema Technology's Expert Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/hire-php-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Looking to hire dedicated PHP developers? Vidhema Technology offers skilled PHP programmers for your web development projects. Join our team and work on innovative solutions.."
          },
          {
              "name": "keyword",
              "content": "hire PHP developers, dedicated PHP programmers, PHP web development, PHP coding experts, backend development jobs"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Dedicated PHP Developers | PHP Web Development Company in India",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as a dedicated PHP developer. Work on challenging web projects and advance your career in PHP development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
         
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-php-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Looking to hire PHP Developers? Vidhema Technologies has a team of the best PHP Programmers who are experienced, dynamic, & trustworthy. Hire Dedicated & Expert PHP Developers & Programmers."
            },
            {
              "name": "twitter:title",
              "content": "Hire Dedicated PHP Developers | PHP Web Development Company in India",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
    "HirePython": {
      "title": "Hire Python Developers | Join Vidhema Technology's Innovative Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-python-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring skilled Python Developers. Join our dynamic team to work on cutting-edge projects, from web applications to data science solutions."
          },
          {
              "name": "keyword",
              "content": "Python developer job, hire Python programmer, Python coding career, software engineering position, data science opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Python Developers | Hire Python Developers from India",
            },
            {
              "property": "og:description",
              "content": "Hire Python Developers at Vidhema Technology"
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-python-developers.html"
            },
         
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire Top Python Developers from India with Vidhema Technologies. Leverage the expertise of Python programmers by hiring our team of professionals. Post your request now!"
            },
            {
              "name": "twitter:title",
              "content": "Hire Python Developers | Hire Python Developers from India",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
         
        ]
    
    },
   
    "HireShopify": {
      "title": "Hire Shopify Developers | Join Vidhema Technology's E-commerce Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-shopify-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is seeking skilled Shopify Developers. Join our e-commerce team to create innovative online stores and advance your career in Shopify development."
          },
          {
              "name": "keyword",
              "content": "Shopify developer job, hire e-commerce programmer, Liquid templating, online store development, tech job opportunity"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Shopify Developers at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "join Vidhema Technology as a Shopify Developer. Create cutting-edge online stores and grow your career in e-commerce development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
            
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-shopify-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire Shopify Developers from Vidhema Techologies. Our Shopify Experts are trusted & build scalable, robust, & user-friendly Shopify apps & websites for your online store."
            },
            {
              "name": "twitter:title",
              "content": "Hire Shopify Developers | Hire Shopify Expert",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireMagento": {
      "title": "Hire Magento Developers | Join Vidhema Technology's E-commerce Experts ",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-magento-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology is hiring skilled Magento Developers. Join our team to build powerful e-commerce solutions and advance your career in Magento development."
          },
          {
              "name": "keyword",
              "content": "Magento developer job, hire e-commerce programmer, Magento 2 expert, PHP developer, e-commerce solutions"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Magento Developers at Vidhema Technology ",
            },
            {
              "property": "og:description",
              "content": "Join Vidhema Technology as a Magento Developer. Build innovative e-commerce solutions and grow your career in Magento development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-magento-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Are you looking for a Magento Developer? Hire Certified Magento Developers from Vidhema, a renowned Magento Development Company India. Contact us to hire Magento Experts."
            },
            {
              "name": "twitter:title",
              "content": "Hire Magento Developers India | Hire Dedicated Magento Developers ",
            },
          
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    
    "HireWoocommerce": {
      "title": "Hire WooCommerce Developers | WooCommerce Programmers",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-woocommerce-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire WooCommerce Developers, Engineers, & Programmers on an hourly, weekly, or monthly basis. Get the best Custom WooCommerce Development in a cost-effective way."
          },
          {
              "name": "keyword",
              "content": "hire woocommerce developers, woocommerce developers, woocommerce development, woocommerce theme development, woocommerce development agency, custom woocommerce development, woocommerce plugin developers"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire WooCommerce Developers | WooCommerce Programmers",
            },
            {
              "property": "og:description",
              "content": "Hire WooCommerce Developers, Engineers, & Programmers on an hourly, weekly, or monthly basis. Get the best Custom WooCommerce Development in a cost-effective way."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          ,
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-woocommerce-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire WooCommerce Developers, Engineers, & Programmers on an hourly, weekly, or monthly basis. Get the best Custom WooCommerce Development in a cost-effective way."
            },
            {
              "name": "twitter:title",
              "content": "Hire WooCommerce Developers | WooCommerce Programmers",
            },
         
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
      
        ]
    
    },
    "HireWordpress": {
      "title": "Hire WordPress Developers | Join Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-wordpress-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Join Vidhema Technology as a WordPress Developer. We're seeking skilled professionals to create innovative, responsive websites for our global clients."
          },
          {
              "name": "keyword",
              "content": "WordPress developer jobs, hire WordPress experts, web development careers, PHP developer positions, CMS specialist jobs."
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire WordPress Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join our team of WordPress experts at Vidhema Technology. Build innovative websites for global clients and grow your career in web development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-wordpress-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Looking to hire WordPress Developers in India? Our team of dedicated WordPress programmers & experts have adroit skills in developing WordPress website, Themes & Plugins."
            },
            {
              "name": "twitter:title",
              "content": "Hire WordPress Developers | Hire Wordpress Programmers",
            },
        
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireDrupal": {
      "title": "Hire Expert Drupal Developers | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-drupal-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire skilled Drupal developers from Vidhema Technology. Our experts deliver custom Drupal solutions, from website development to complex web applications."
          },
          {
              "name": "keyword",
              "content": "hire Drupal developer, Drupal expert, custom Drupal development, Drupal website, Drupal web application"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Expert Drupal Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Boost your web projects with our skilled Drupal developers. Custom solutions, expert development, and timely delivery guaranteed."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-drupal-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Looking to hire a Drupal developer to develop a website from scratch? We have a team of 25+ drupal developers to build next-gen websites for your business."
            },
            {
              "name": "twitter:title",
              "content": "Hire a Drupal Developer | Drupal Developers",
            },
          
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireWix": {
      "title": "Hire Expert Wix Developers | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-wix-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire skilled Wix developers from Vidhema Technology. Our experts create stunning, responsive websites tailored to your business needs. Get professional Wix development services today."
          },
          {
              "name": "keyword",
              "content": "hire Wix developer, Wix expert, Wix website development, custom Wix sites, professional Wix services"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Expert Wix Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Looking to hire skilled Wix developers? Vidhema Technology offers expert Wix development services for stunning, responsive websites."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/hire-wix-developers.html"
            },
            {
              "property": "og:site_name",
              "content": "Vidhema"
            },
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "We offer flexible ways to hire Wix developers and designers with expertise in crafting high-performance apps & websites offering customized Wix solutions under your budget."
            },
            {
              "name": "twitter:title",
              "content": "Hire Wix Developers | Hire Wix Designers",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
    "HireVue": {
      "title": "Hire Vue.js Developer | Join Vidhema Technology's Expert Team",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-vue-js-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Join Vidhema Technology as a Vue.js Developer. We're seeking skilled professionals to create cutting-edge web applications. Apply now and shape the future of web development."
          },
          {
              "name": "keyword",
              "content": "hire vue js developers, vue js developers, vue js, hire vue developers, vue js development company, vue js development servicesVue.js developer, frontend developer, JavaScript jobs, web development careers, hire Vue.js expert"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Vue.js Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Join our team as a Vue.js Developer at Vidhema Technology. Create innovative web applications and advance your career in frontend development."
            },
            {
              "property": "og:type",
              "content": "website"
            },
         
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-vue-js-developers.html"
            },
            
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire Vue JS Developers to experience real-time web apps. Get quick access to our experienced Vue JS Development Services to amplify the growth of your business."
            },
            {
              "name": "twitter:title",
              "content": "Hire Vue JS Developers | Vue JS Development Company",
            },
            
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
    "HireAngular": {
      "title": "Hire Angular Developers | Expert Angular Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-angular-js-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire expert Angular developers from Vidhema Technology. Our skilled team delivers robust, scalable, and high-performance Angular applications tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "hire Angular developers, Angular development services, expert Angular programmers, custom Angular applications, front-end development"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Angular Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Get expert Angular development services from Vidhema Technology. Hire our skilled Angular developers for your next project."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-angular-js-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire Angular JS Developers from us to build performant & robust web apps. We offer affordable Angular Developers that help you kick-start your business."
            },
            {
              "name": "twitter:title",
              "content": "Hire AngularJS Developer | 50+ Senior Angular Developers",
            },
          
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
          
        ]
    
    },
    "HireNode": {
      "title": "Hire Expert NodeJS Developers | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-node-js-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire skilled NodeJS developers from Vidhema Technology. Get expert Node.js development services for your web applications and server-side projects."
          },
          {
              "name": "keyword",
              "content": "hire NodeJS developer, Node.js expert, JavaScript developer, backend development, server-side programming"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire Expert NodeJS Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Get top-tier NodeJS development services. Hire skilled developers from Vidhema Technology for your next project."
            },
            {
              "property": "og:type",
              "content": "website"
            },
         
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-node-js-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "We are the top Node JS Development Company that offers you to hire Nodejs Developers for your upcoming projects. Connect with us for Node js Programmer."
            },
            {
              "name": "twitter:title",
              "content": "Hire Nodejs Developer | Node js Programmer",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireReact": {
      "title": "Hire ReactJS Developers | Expert React Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-react-js-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire expert ReactJS developers from Vidhema Technology. Get top-notch React development services for your web applications. Skilled, experienced, and ready to join your team. "
          },
          {
              "name": "keyword",
              "content": "hire ReactJS developer, React development services, expert React programmers, ReactJS consulting, frontend development"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire ReactJS Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Hire expert ReactJS developers from Vidhema Technology. Get top-notch React development services for your web applications. "
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-react-js-developers.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Hire React JS Developer from Vidhema Technologies who are highly experienced & certified in their work. You can hire a React programmer team to grow your business in a competitive market. "
            },
            {
              "name": "twitter:title",
              "content": "Hire React JS Developer | React Programmer",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
            
        ]
    
    },
    "HireNFTEcommerce": {
      "title": "Hire NFT E-Commerce Developer | Join Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-nft-ecommerce-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content":"Exciting opportunity for an NFT E-Commerce Developer at Vidhema Technology. Join our innovative team and work on cutting-edge blockchain and e-commerce projects."
          },
          {
              "name": "keyword",
              "content": "NFT developer, e-commerce developer, blockchain jobs, web3 careers, smart contract developer"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire NFT E-Commerce Developer at Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "xpert NFT E-Commerce Developers available for hire. Build innovative blockchain-based digital marketplaces and NFT platforms with Vidhema Technology."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-nft-ecommerce-developers.html"
            },
            
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Vidhema Technologies is offering tremendous services of NFT Market, NFT art, etc. Connect with us & get a demo of our Non-Fungible Token offerings. Click to learn more!"
            },
            {
              "name": "twitter:title",
              "content": "NFT Ecommerce Platform: Experience the best - Vidhema Technologies",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
    "HireNFTMarketplace": {
      "title": "Hire NFT Marketplace Developers | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://vidhema.com/hire-nft-marketplace-developers.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Hire expert NFT Marketplace Developers from Vidhema Technology. Our skilled team specializes in blockchain technology, smart contracts, and creating secure, scalable NFT platforms."
          },
          {
              "name": "keyword",
              "content": "NFT developers, blockchain experts, smart contract developers, NFT marketplace creation, hire blockchain developers"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Hire NFT Marketplace Developers | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Get expert NFT Marketplace Developers from Vidhema Technology. Specialized in blockchain, smart contracts, and secure NFT platforms."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://vidhema.com/hire-nft-marketplace-developers.html"
            },
           
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "Our NFT Marketplace Development Services offers a promising source of revenue. Let’s work together & build a stellar NFT Marketplace Crypto world & come across the leading NFT Platforms."
            },
            {
              "name": "twitter:title",
              "content": "Professional NFT Marketplace Website Development | NFT Marketplace Development Company",
            },
        
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
          
        ]
    
    },
    

    "AndroidAppDev": {
      "title": "Android App Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
      "canonical":"https://www.vidhema.com/android-app-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology offers professional Android app development services. Get custom Android app solutions tailored to your business needs "
          },
          {
              "name": "keyword",
              "content": "Android app development, mobile app development, custom Android apps, Android development services, IT services"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Android App Development Services | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Vidhema Technology offers professional Android app development services. Get custom Android app solutions tailored to your business needs."
            },
            {
              "property": "og:type",
              "content": "website"
            },
          
            {
              "property": "og:url",
              "content": "https://www.vidhema.com/android-app-development.html"
            },
         
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "We offer custom Android App Development Services provided by our expert team of Android App Developers. Connect with us to get prolific Android development services for your business."
            },
            {
              "name": "twitter:title",
              "content": "Android App Development Company in India | Hire Android Developers",
            },
            
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
         
        ]
    
    },
    
   
   
    "IonicAppDev": {
      "title": "Ionic App Development Services | Vidhema Technology",
      "titleTemplate": "%s | Vidhema Technologies",
        "canonical":"https://vidhema.com/ionic-development.html",
      "meta": [
        {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0"
        },
          {
          "name": "description",
          "content": "Vidhema Technology offers expert Ionic app development services. Our team delivers high-quality hybrid mobile applications tailored to your business needs."
          },
          {
              "name": "keyword",
              "content": "Ionic app development, hybrid mobile apps, cross-platform apps, mobile app development, custom app solutions"
            },
            {
              "name":"revisit-after",
              "content":"7 days",
            },
            {
              "property": "og:title",
              "content":"Ionic App Development Services | Vidhema Technology",
            },
            {
              "property": "og:description",
              "content": "Vidhema Technology offers expert Ionic app development services. Our team delivers high-quality hybrid mobile applications tailored to your business needs."
            },
            {
              "property": "og:type",
              "content": "website"
            },
           
            {
              "property": "og:url",
              "content": "https://vidhema.com/ionic-development.html"
            },
          
            {
              "property": "og:image",
              "content": "https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022824164358-143hire-developers-all.jpg"
            },
            {
              "name": "twitter:card",
              "content": "summary_large_image"
            },

            {
              "name": "twitter:description",
              "content":  "We are a top-notch Ionic Mobile App Development Company in India. Our team of expert Ionic Developers builds Ionic Framework & offers cost-effective Ionic App Development solutions."
            },
            {
              "name": "twitter:title",
              "content": "Ionic App Development Company | Ionic App Developers in Singapore",
            },
           
            {
              "name": "twitter:image",
              "content": "https://images.vidhema.com/Vidhema/VidhemaBlogImages/202132212722-899bgheadernew.jpg"
            },
           
        ]
    
    },
   
   

  }
  static CareerDev: any;
}